import React from "react";
import Button from "../../button/button";

// import "./NavigationItems.css";
import "./pageItems.css";

function PageItems(props) {
  return (
    <li>
      <div className="page-item">
        <div className="page-top">
          <h3>{props.name}</h3>
          <p>{props.description}</p>
        </div>
        <div>
          {props.isAuth && (
            <>
              <Button design="flat" mode="danger" onClick={props.onDelete}>
                Delete
              </Button>
              <Button design="flat" onClick={props.onStartEdit}>
                Edit
              </Button>
            </>
          )}
        </div>
      </div>
    </li>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default PageItems;
